import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const FormSectionHeading = props => (
  <Box style={props.style || {}}>
    <Typography variant={props.textVariant || 'formLabel'} style={{paddingBottom: '0em'}}>
      {props.title}
    </Typography>
    <Typography variant={props.subtitleVariant || 'body1'} style={{marginTop: '0.25em'}}>
      {props.subtitle}
    </Typography>
  </Box>
);

export default FormSectionHeading;
